import {IMapEnumElement} from "./interface";
import {MapEnum} from "./MapEnum";

export abstract class BaseMapEnum  {
    protected _id: number | undefined;
    protected _name: string | undefined;
    protected _owner: typeof MapEnum | undefined;
    protected _fieldName: string | undefined;
    protected _parent?: IMapEnumElement;

    get [Symbol.toStringTag]() {
        return "Map Enum";
    }

    [Symbol.toPrimitive](hint: "default"): string;
    [Symbol.toPrimitive](hint: "string"): string;
    [Symbol.toPrimitive](hint: "number"): number;
    [Symbol.toPrimitive](hint: string): string | number;
    [Symbol.toPrimitive](hint: "default" | "string" | "number" | string): string | number {
        if (hint === 'number') {
            return this?._id ?? -1;
        } else {
            return this?._fieldName ?? "";
        }
    }

    equals(mapEnum: IMapEnumElement): boolean {
        if (mapEnum?.owner) {
            if (this.constructor !== mapEnum.owner) {
                return false;
            }
        }
        if (mapEnum?.id) {
            return this._id === mapEnum.id;
        } else {
            return false;
        }
    }

}

